import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayerMigrationComponent } from './player-migration.component';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { PlayerMigrationActionComponent } from './player-migration-action.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PlayerMigrationComponent,
    PlayerMigrationActionComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule,
    ReactiveFormsModule
  ]
})
export class PlayerMigrationModule { }
